import React, { useEffect, useState, useContext, useRef } from 'react';
import { AuthContext } from '../contexts/auth';
import Footer from '../components/footer';
import FormCreaRimborsoCompany from "../components/form_crea_rimborso_company";
import FormCreaRimborsoKmCompany from '../components/form_crea_rimborso_km_company';
import { createRimborsoSpese, processRichiestaRimborso, deleteRichiestaRimborso, processAllRefundRequests, processAllMileageRefundRequests, updateRatePerKm, summaryRefundRequests, listaRichiesteRimborsoSpeseCompany } from '../services/api_cost_refunds';
import Swal from 'sweetalert2';
import Fetching from "../components/fetching";
import moment from 'moment';
import { Link } from 'wouter';
import { ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import CalendarMonthSelect from '../components/calendar_month_select';
import { exportCostRefunds } from '../services/api_extractions';
import MonthYearListbox from '../components/month_year_listbox';
import PopoverComponentCustom from '../components/popover_component';
import ListBoxQueryMultiSelectEmployeesActiveContract from '../components/list_box_query_employee_active_contract';
import PendingRefundRequests from '../components/pending_refund_requests';
import HandledRefundRequests from '../components/handled_refund_requests';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { estraiMessaggiErrore } from '../services/utils';


const RimborsoSpeseCompany = () => {
  const { token, profile } = useContext(AuthContext);

  // stati caricamento / errore
  const [isLoadingPending, setIsLoadingPending] = useState(false);
  const [isLoadingHandled, setIsLoadingHandled] = useState(false);
  const [isLoadingTotals, setIsLoadingTotals] = useState(false);
  const [isError, setIsError] = useState(false);

  // liste (già raggruppate per employee dal BE)
  const [recordToReview, setRecordToReview] = useState([]); // pending (status=null)
  const [records, setRecords] = useState([]);               // handled (approved/rejected)

  // pagine (dal BE)
  const [currentPageNull, setCurrentPageNull] = useState(1);
  const [totalPagesNull, setTotalPagesNull] = useState(1);
  const [currentPageNoNull, setCurrentPageNoNull] = useState(1);
  const [totalPagesNoNull, setTotalPagesNoNull] = useState(1);

  // form / UI
  const [showForm, setShowForm] = useState(false);
  const [showFormRimborsoKm, setShowFormRimborsoKm] = useState(false);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);

  // filtri / selezioni
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedMonthCalendar, setSelectedMonthCalendar] = useState(new Date());

  // apertura gruppi employee
  const [openEmployeeCfHandled, setOpenEmployeeCfHandled] = useState(null);
  const [openEmployeeCfPending, setOpenEmployeeCfPending] = useState(null);

  const [pendingDetails, setPendingDetails] = useState({}); // { [employeeId]: refunds[] }
  const [handledDetails, setHandledDetails] = useState({});
  const loadingRef = React.useRef({ pending: {}, handled: {} });


  // --- totali (dalla summary) ESISTENTI ---
  const [totalPendingCount, setTotalPendingCount] = useState(0);
  const [pendingCostCount, setPendingCostCount] = useState(0);
  const [pendingMileageCount, setPendingMileageCount] = useState(0);

  // --- NUOVI totali GLOBALI (non filtrati per employee) ---
  const [globalPendingCount, setGlobalPendingCount] = useState(0);
  const [globalPendingCostCount, setGlobalPendingCostCount] = useState(0);
  const [globalPendingMileageCount, setGlobalPendingMileageCount] = useState(0);

  const mm = selectedMonthCalendar.getMonth() + 1;
  const yy = selectedMonthCalendar.getFullYear();

  const controller = useRef(null);
  const bothController = useRef(null);

  const isProfileComplete = profile.has_complete_profile;


  // --- HELPERS: una per pending, una per handled, una per entrambe ---
  const fetchPendingSummary = async () => {
    const mm = selectedMonthCalendar.getMonth() + 1;
    const yy = selectedMonthCalendar.getFullYear();
    setIsLoadingPending(true);
    setIsError(false);
    try {
      // NB: passa status='pending'
      const res = await summaryRefundRequests(
        token, mm, yy,
        'all',
        currentPageNull,       // pending_page
        1,                     // handled_page ignorata dal BE (mettila pure a 1)
        10,
        'cost_refunds',
        selectedEmployee ? [selectedEmployee.id] : undefined,
        'pending'              // <<< nuovo parametro
      );

      // Totali (sono globali, ok aggiornarli da qui)
      const totals = res?.totals || {};
      setTotalPendingCount(Number(totals.pending_count || 0));
      setPendingCostCount(Number(totals.pending_cost_count || 0));
      setPendingMileageCount(Number(totals.pending_mileage_count || 0));

      // Pending list
      const p = res?.pending_employees || {};
      setRecordToReview(p.results || []);
      setTotalPagesNull(
        Number(p.total_pages || p.num_pages || Math.max(1, Math.ceil((p.count || 0) / 10)))
      );
    } catch (err) {
      if (err?.name != 'CanceledError') {
        console.error(err);
        setIsError(true);
      }
    } finally {
      setIsLoadingPending(false);
    }
  };

  const fetchGlobalTotals = async () => {
    setIsLoadingTotals(true);
    setIsError(false);

    if (controller.current) {
      controller.current.abort();
    }
    controller.current = new AbortController();
    const signal = controller.current.signal;

    const mm = selectedMonthCalendar.getMonth() + 1;
    const yy = selectedMonthCalendar.getFullYear();

    try {
      const res = await summaryRefundRequests(
        token,
        mm,
        yy,
        'all',
        1,   // pending_page
        1,   // handled_page
        1,   // page_size: minimo, leggiamo solo totals
        'cost_refunds',
        undefined, // nessun employee_id
        'all',
        signal     // <-- come nel tuo esempio
      );

      const t = res?.totals || {};
      setGlobalPendingCount(Number(t.pending_count || 0));
      setGlobalPendingCostCount(Number(t.pending_cost_count || 0));
      setGlobalPendingMileageCount(Number(t.pending_mileage_count || 0));
    } catch (err) {
      if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') return;

      console.error('fetchGlobalTotals error:', err);
      setIsError(true);

      setGlobalPendingCount(0);
      setGlobalPendingCostCount(0);
      setGlobalPendingMileageCount(0);
    } finally {
      setIsLoadingTotals(false);
    }
  };

  const fetchHandledSummary = async () => {
    const mm = selectedMonthCalendar.getMonth() + 1;
    const yy = selectedMonthCalendar.getFullYear();
    setIsLoadingHandled(true);
    setIsError(false);
    try {
      // NB: passa status='handled'
      const res = await summaryRefundRequests(
        token, mm, yy,
        'all',
        1,                     // pending_page ignorata dal BE in questa chiamata
        currentPageNoNull,     // handled_page
        10,
        'cost_refunds',
        selectedEmployee ? [selectedEmployee.id] : undefined,
        'handled'              // <<< nuovo parametro
      );

      // Totali (globali)
      const totals = res?.totals || {};
      setTotalPendingCount(Number(totals.pending_count || 0));
      setPendingCostCount(Number(totals.pending_cost_count || 0));
      setPendingMileageCount(Number(totals.pending_mileage_count || 0));

      // Handled list
      const h = res?.handled_employees || {};
      setRecords(h.results || []);
      setTotalPagesNoNull(
        Number(h.total_pages || h.num_pages || Math.max(1, Math.ceil((h.count || 0) / 10)))
      );
    } catch (err) {
      if (err?.name != 'CanceledError') {
        console.error(err);
        setIsError(true);
      }
    } finally {
      setIsLoadingHandled(false);
    }
  };

  const fetchBothSummary = async () => {
    if (bothController.current) bothController.current.abort();
    bothController.current = new AbortController();
    const signal = bothController.current.signal;

    const mm = selectedMonthCalendar.getMonth() + 1;
    const yy = selectedMonthCalendar.getFullYear();
    setIsLoadingPending(true);
    setIsLoadingHandled(true);
    setIsError(false);
    try {
      // NB: una sola chiamata con status='all' popola entrambe
      const res = await summaryRefundRequests(
        token, mm, yy,
        'all',
        currentPageNull,       // pending_page
        currentPageNoNull,     // handled_page
        10,
        'cost_refunds',
        selectedEmployee ? [selectedEmployee.id] : undefined,
        'all',
        signal
      );

      const totals = res?.totals || {};
      setTotalPendingCount(Number(totals.pending_count || 0));
      setPendingCostCount(Number(totals.pending_cost_count || 0));
      setPendingMileageCount(Number(totals.pending_mileage_count || 0));

      const p = res?.pending_employees || {};
      setRecordToReview(p.results || []);
      setTotalPagesNull(
        Number(p.total_pages || p.num_pages || Math.max(1, Math.ceil((p.count || 0) / 10)))
      );

      const h = res?.handled_employees || {};
      setRecords(h.results || []);
      setTotalPagesNoNull(
        Number(h.total_pages || h.num_pages || Math.max(1, Math.ceil((h.count || 0) / 10)))
      );
    } catch (err) {
      if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') return;

      console.error(err);
      setIsError(true);
    } finally {
      setIsLoadingPending(false);
      setIsLoadingHandled(false);
    }
  };

  useEffect(() => {
    return () => {
      if (controller.current) controller.current.abort();
      if (bothController.current) bothController.current.abort();
    };
  }, []);


  async function fetchAllMergedPages({ status, employeeId, pageSize = 100 }) {
    let page = 1;
    let out = [];

    while (true) {
      const data = await listaRichiesteRimborsoSpeseCompany(
        token,
        page,
        status,
        pageSize,
        mm,
        yy,
        'cost_refunds',
        [employeeId],
      );

      out = out.concat(Array.isArray(data?.results) ? data.results : []);

      const hasNext = !!(data?.next_cost || data?.next_mileage);
      if (!hasNext) break;

      page += 1;
    }

    out.sort((a, b) => {
      const da = new Date(a.date || a.created_at || 0).getTime();
      const db = new Date(b.date || b.created_at || 0).getTime();
      return db - da;
    });

    return out;
  }

  async function loadEmployeeDetails(section, employeeId, options = {}) {
    const { force = false } = options;

    const cache = section === 'pending' ? pendingDetails : handledDetails;

    // Evita doppie chiamate, ma consenti il bypass se force === true
    if (!force && (cache[employeeId] || loadingRef.current[section][employeeId])) return;

    loadingRef.current[section][employeeId] = true;
    try {
      const status = section === 'pending' ? 'null' : 'no_null';

      // SCARICA TUTTO (cost+mileage) e poi pagini lato front nel child
      const mergedAll = await fetchAllMergedPages({ status, employeeId, pageSize: 100 });

      if (section === 'pending') {
        setPendingDetails((prev) => ({ ...prev, [employeeId]: mergedAll }));
      } else {
        setHandledDetails((prev) => ({ ...prev, [employeeId]: mergedAll }));
      }
    } finally {
      delete loadingRef.current[section][employeeId];
    }
  }

  // reset pagina quando cambia mese o dipendente
  useEffect(() => {
    setCurrentPageNull(1);
    setCurrentPageNoNull(1);
    setOpenEmployeeCfPending(null);

    // invalida le cache dei dettagli (pending/handled)
    setPendingDetails({});
    setHandledDetails({});

    // pulisci i flag anti-doppia-chiamata
    loadingRef.current = { pending: {}, handled: {} };

    // chiudi eventuali righe di dettaglio “refund”
    setOpenEmployeeCfPending?.(null);
    setOpenEmployeeCfHandled?.(null);

  }, [selectedMonthCalendar, selectedEmployee?.id]);

  // carica summary quando cambiano mese / pagine / filtro employee
  useEffect(() => {
    fetchBothSummary();
    fetchGlobalTotals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonthCalendar, currentPageNull, currentPageNoNull, selectedEmployee?.id]);

  // ---------- SUBMIT (crea) ----------
  const submitForm = async (formData) => {
    try {
      const response = await createRimborsoSpese(token, formData);
      // rinfresco da BE per avere importi & totali coerenti
      await fetchBothSummary();
      return response;
    } catch (error) {
      // propaghiamo l’errore al form che mostrerà lo Swal
      throw error;
    }
  };

  const handleAfterSubmit = async () => {
    await withPreservedScroll(async () => {
      await fetchBothSummary();
      await fetchGlobalTotals(); 
      await Promise.all([
        reloadAllSectionDetails('pending'),
        reloadAllSectionDetails('handled'),
      ]);
    });
    setShowForm(false);
    setShowFormRimborsoKm(false);
  };


  

  // ---------- Azioni singole ----------
  const refreshAfterStatusChange = async (beforeStatus, afterStatus) => {
    const wasPending = beforeStatus == null;
    const goesHandled = afterStatus === 'approved' || afterStatus === 'rejected';

    if (wasPending && goesHandled) {
      await Promise.all([fetchPendingSummary(), fetchHandledSummary()]);
    } else {
      // era già handled e rimane handled (approved <-> rejected)
      await fetchHandledSummary();
    }
  };

  // Helpers ---------------------------------------------------------
  const reloadAllSectionDetails = async (section) => {
    const cache = section === 'pending' ? pendingDetails : handledDetails;
    const ids = Object.keys(cache || {}).map(Number).filter(Boolean);
    if (!ids.length) return;
    await Promise.all(ids.map(id => loadEmployeeDetails(section, id, { force: true })));
  };

  const reloadEmployeeDetailsBoth = async (employeeId) => {
    await Promise.all([
      loadEmployeeDetails('pending', employeeId, { force: true }),
      loadEmployeeDetails('handled', employeeId, { force: true }),
    ]);
  };

  // --- Preserva/restore scroll durante refresh asincroni ---
  const withPreservedScroll = async (fn) => {
    const y = window.scrollY;
    try {
      return await fn();
    } finally {
      // restituisci lo scroll dopo il paint
      requestAnimationFrame(() => {
        window.scrollTo({ top: y, left: 0, behavior: 'auto' });
      });
    }
  };

  const updateRecordStatus = async (currentRecord, status, refundKind) => {
    try {
      await processRichiestaRimborso(token, currentRecord.id, status, refundKind);
      await Swal.fire({ title: 'Salvato!', icon: 'success', timer: 1500, showConfirmButton: false });

      await withPreservedScroll(async () => {
        await fetchBothSummary();
        await fetchGlobalTotals();
        await reloadEmployeeDetailsBoth(currentRecord?.employee?.id);
      });
    } catch (error) {
      const msg = estraiMessaggiErrore(error);
      await Swal.fire({ icon: 'error', title: 'Errore', html: msg.replace(/\n/g, '<br>') });
    }
  };

  const handleDelete = async (_record, id, refundKind) => {
    const result = await Swal.fire({
      title: 'Sei sicuro?',
      text: "Stai eliminando la richiesta di un rimborso e l'operazione non è reversibile. Confermi l'eliminazione?",
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sì, confermo',
      cancelButtonText: 'No, annulla',
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      await deleteRichiestaRimborso(token, id, refundKind);
      await Swal.fire({
        title: 'Eliminato!',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
      await withPreservedScroll(async () => {
        await fetchBothSummary();
        await fetchGlobalTotals();

        const empId = _record?.employee?.id ?? _record?.employee_id;
        if (empId) {
          const section = _record?.status == null ? 'pending' : 'handled';
          await loadEmployeeDetails(section, empId, { force: true });

          // (opzionale) ri-ancora/lascia aperta la riga dell’employee
          const empCf = _record?.employee?.cf ?? _record?.employee_cf;
          if (empCf) {
            if (section === 'pending') setOpenEmployeeCfPending(empCf);
            else setOpenEmployeeCfHandled(empCf);
          }
        }
      });
    } catch (error) {
      let errorMessage = 'Errore durante l\'eliminazione.';
      const data = error?.response?.data;
      if (data) {
        const msgs = [];
        if (typeof data === 'string') msgs.push(data);
        else if (Array.isArray(data)) msgs.push(...data);
        else if (typeof data === 'object') {
          Object.values(data).forEach((v) => {
            if (typeof v === 'string') msgs.push(v);
            else if (Array.isArray(v)) msgs.push(v.join(', '));
            else if (v && typeof v === 'object') msgs.push(Object.values(v).flat().join(', '));
          });
        }
        if (msgs.length) errorMessage = msgs.join('\n');
      }
      await Swal.fire('Errore', errorMessage, 'error');
    }
  };

  // ---------- Toggle form ----------
  const toggleForm = () => setShowForm((v) => !v);
  const toggleFormRimborsoKm = () => setShowFormRimborsoKm((v) => !v);

  // ---------- Edit status già gestito ----------
  const handleEditStatus = async (record) => {
    const statusMapping = { approved: 'approvata', rejected: 'rifiutata' };
    const formattedDate = moment(record.reviewed_on).format('DD/MM/YYYY');

    const currentStatus = statusMapping[record.status] || record.status;
    const newStatus = record.status === 'approved' ? 'rejected' : 'approved';
    const newStatusLabel = statusMapping[newStatus] || newStatus;

    let reviewedByText = '';
    if (record.reviewed_by) {
      const hasName = record.reviewed_by.last_name && record.reviewed_by.first_name;
      if (hasName) reviewedByText = ` da ${record.reviewed_by.last_name} ${record.reviewed_by.first_name}`;
      else if (record.reviewed_by.cf) reviewedByText = ` da CF: ${record.reviewed_by.cf}`;
    }

    const message = `La richiesta è stata ${currentStatus} in data ${formattedDate}${reviewedByText}.<br>Confermi di volerla ${newStatusLabel === 'approvata' ? 'approvare' : 'rifiutare'}?`;

    const result = await Swal.fire({
      title: 'Modifica Status Richiesta',
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Conferma e modifica`,
      cancelButtonText: 'Annulla',
    });

    if (result.isConfirmed) {
      await updateRecordStatus(record, newStatus, record.type || record.refund_kind);
    }
  };

  // helper: prende i totali GLOBALI freschi, ignorando filtro employee
  const getFreshGlobalPendingTotals = async () => {
    const mmExec = selectedMonthCalendar.getMonth() + 1;
    const yyExec = selectedMonthCalendar.getFullYear();

    const res = await summaryRefundRequests(
      token, mmExec, yyExec,
      'all',
      1,    // pending_page
      1,    // handled_page
      1,    // page_size minimo: ci bastano i totals
      'cost_refunds',
      undefined, // <-- NESSUN employee_id
      'all'
    );

    const t = res?.totals || {};
    const totals = {
      total:   Number(t.pending_count || 0),
      cost:    Number(t.pending_cost_count || 0),
      mileage: Number(t.pending_mileage_count || 0),
    };

    // opzionale: aggiorna anche gli state globali
    setGlobalPendingCount(totals.total);
    setGlobalPendingCostCount(totals.cost);
    setGlobalPendingMileageCount(totals.mileage);

    return totals;
  };

  // ---------- Bulk process (approve/reject all) ----------
  const handleProcessAllRequests = async (status, employee = null, refunds = [], totalEmployeePending = null) => {
    const approve    = status === 'approved';
    const actionVerb = approve ? 'approvare' : 'rifiutare';
    const titleTxt   = approve ? 'Conferma approvazione' : 'Conferma rifiuto';
    const confirmTxt = approve ? 'Sì, approva' : 'Sì, rifiuta';
    const doneTxt    = approve ? 'Approvate!' : 'Rifiutate!';

    const isCost    = r => (r.refund_kind || r.type) === 'regular' || r.type === 'cost';
    const isMileage = r => (r.refund_kind || r.type) === 'mileage';
    const isPending = r => r.status == null;

    let costCount = 0;
    let mileageCount = 0;
    let displayTotal = 0;   // numero da mostrare nello Swal

    if (employee) {
      // ——— SINGOLO DIPENDENTE ———
      let list = (Array.isArray(refunds) && refunds.length)
        ? refunds
        : (pendingDetails?.[employee.id] || []);

      if (!list.length) {
        try {
          const resp = await listaRichiesteRimborsoSpeseCompany(
            token, 1, 'null', null, mm, yy, 'cost_refunds', [employee.id]
          );
          list = resp?.results || [];
        } catch { list = []; }
      }

      const pendenti = list.filter(isPending);
      costCount    = pendenti.filter(isCost).length;
      mileageCount = pendenti.filter(isMileage).length;

      // nello Swal usa il totale passato dal figlio (somma delle 2 API paginabili) se disponibile
      displayTotal = Number(totalEmployeePending ?? 0) || (costCount + mileageCount);

    } else {
      // ——— AZIONE GLOBALE ———
      // NON leggere gli state (possono essere stantii): prendi totali freschi dalla API
      const totals = await getFreshGlobalPendingTotals();
      costCount    = totals.cost;
      mileageCount = totals.mileage;
      displayTotal = totals.total;           // per lo Swal
    }

    // decido se procedere tecnicamente
    const technicalTotal = costCount + mileageCount;
    if (!employee) {
      // per il globale, se breakdown = 0 ma total > 0, fa fede il total
      if (technicalTotal === 0 && displayTotal > 0) {
        // ok, andiamo avanti (il BE restituirà "0" per il tipo che non ha pending)
      } else if (technicalTotal === 0) {
        await Swal.fire({ icon: 'info', title: 'Niente da fare', text: 'Non ci sono richieste pendenti da elaborare.' });
        return;
      }
    } else if (technicalTotal === 0) {
      await Swal.fire({ icon: 'info', title: 'Niente da fare', text: 'Non ci sono richieste pendenti da elaborare.' });
      return;
    }

    const empLabel = employee
      ? (employee.last_name && employee.first_name ? `${employee.last_name} ${employee.first_name}` : employee.cf)
      : '';

    const { isConfirmed } = await Swal.fire({
      title: titleTxt,
      text: `Confermi di voler ${actionVerb} ${displayTotal} richieste${empLabel ? ` di ${empLabel}` : ' di tutti i dipendenti'}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmTxt,
      cancelButtonText: 'Annulla',
    });
    if (!isConfirmed) return;

    const yyExec = selectedMonthCalendar.getFullYear();
    const mmExec = selectedMonthCalendar.getMonth() + 1;

    // Prepara le azioni
    const actions = [];
    if (employee) {
      if (costCount > 0) {
        actions.push({
          type: 'cost',
          label: 'Rimborsi spese',
          promise: processAllRefundRequests(token, status, yyExec, mmExec, employee.id),
        });
      }
      if (mileageCount > 0) {
        actions.push({
          type: 'mileage',
          label: 'Rimborsi km',
          promise: processAllMileageRefundRequests(token, status, yyExec, mmExec, employee.id),
        });
      }
    } else {
      // globale: se non ho breakdown ma ho displayTotal>0, lancio entrambe (una può tornare 0, è ok)
      const shouldFireBoth = (costCount === 0 && mileageCount === 0 && displayTotal > 0);
      if (costCount > 0 || shouldFireBoth) {
        actions.push({
          type: 'cost',
          label: 'Rimborsi spese',
          promise: processAllRefundRequests(token, status, yyExec, mmExec, undefined),
        });
      }
      if (mileageCount > 0 || shouldFireBoth) {
        actions.push({
          type: 'mileage',
          label: 'Rimborsi km',
          promise: processAllMileageRefundRequests(token, status, yyExec, mmExec, undefined),
        });
      }
    }

    if (actions.length === 0) {
      await Swal.fire({ icon: 'info', title: 'Niente da fare', text: 'Nessuna categoria di rimborso da elaborare.' });
      return;
    }

    try {
      Swal.fire({
        title: `${approve ? 'Approvazione' : 'Rifiuto'} in corso…`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });

      const settled = await Promise.allSettled(actions.map(a => a.promise));
      const normalize = (raw) => {
        const data = raw?.data ?? raw ?? {};
        const total    = Number(data.total_pending ?? data.total ?? data.count ?? 0);
        const approved = Number(data.approved ?? data.updated ?? data.processed ?? 0);
        let skipped    = Number(data.skipped ?? data.not_processed ?? 0);
        if (!skipped && total && approved <= total) skipped = total - approved;
        return { total, approved, skipped, detail: data.detail ?? '' };
      };
      const results = settled.map((s, i) => {
        const meta = actions[i];
        if (s.status === 'fulfilled') return { type: meta.type, label: meta.label, ok: true, ...normalize(s.value) };
        const err = s.reason?.response?.data ?? s.reason?.message ?? 'Errore sconosciuto';
        const errMsg = (typeof err === 'string') ? err : (Object.values(err || {}).flat().join(' ') || 'Errore');
        return { type: meta.type, label: meta.label, ok: false, error: errMsg, total: 0, approved: 0, skipped: 0 };
      });

      await fetchBothSummary();
      await fetchGlobalTotals(); // aggiorna gli state globali per la UI
      if (employee?.id) {
        await reloadEmployeeDetailsBoth(employee.id);
      } else {
        await Promise.all([reloadAllSectionDetails('pending'), reloadAllSectionDetails('handled')]);
      }

      const cost    = results.find(r => r.type === 'cost')    || { total: 0, approved: 0, skipped: 0, ok: true };
      const mileage = results.find(r => r.type === 'mileage') || { total: 0, approved: 0, skipped: 0, ok: true };

      const rowHtml = (label, cVal, mVal) => `
        <tr>
          <td style="padding:8px 10px;border:1px solid #e5e7eb;font-weight:600">${label}</td>
          <td style="padding:8px 10px;border:1px solid #e5e7eb;text-align:center">${cVal}</td>
          <td style="padding:8px 10px;border:1px solid #e5e7eb;text-align:center">${mVal}</td>
        </tr>`;
      const tableHtml = `
        <table style="width:100%;border-collapse:collapse;font-size:14px">
          <thead>
            <tr>
              <th style="padding:8px 10px;border:1px solid #e5e7eb;background:#f3f4f6"></th>
              <th style="padding:8px 10px;border:1px solid #e5e7eb;background:#f3f4f6">Rimborsi spese</th>
              <th style="padding:8px 10px;border:1px solid #e5e7eb;background:#f3f4f6">Rimborsi km</th>
            </tr>
          </thead>
          <tbody>
            ${rowHtml('Elaborate',     cost.approved, mileage.approved)}
            ${rowHtml('Non elaborate', cost.skipped,  mileage.skipped)}
          </tbody>
        </table>`;

      const errorBlocks = [];
      const errorStyle = 'margin-top:6px;color:#4B5563;font-size:16px;line-height:1.25';
      if (cost.ok === false && cost.error)       errorBlocks.push(`<div style="${errorStyle}"><strong>Rimborsi spese:</strong> ${cost.error}</div>`);
      if (mileage.ok === false && mileage.error) errorBlocks.push(`<div style="${errorStyle}"><strong>Rimborsi km:</strong> ${mileage.error}</div>`);

      await Swal.fire({
        icon: results.some(r => !r.ok) ? 'warning' : 'success',
        title: doneTxt,
        html: `${tableHtml}${errorBlocks.length ? `<div style="margin-top:8px">${errorBlocks.join('')}</div>` : ''}`,
        confirmButtonText: 'OK',
      });
    } catch (err) {
      const msg = err?.response?.data
        ? Object.values(err.response.data).flat().join(' ')
        : 'Errore, riprova più tardi.';
      Swal.fire({ icon: 'error', title: 'Errore', text: msg });
    }
  };

  const handleAfterSubmitEditRecord = async (updated) => {
    const empId = updated?.employee?.id ?? updated?.employee_id;
    const empCf = updated?.employee?.cf ?? updated?.employee_cf;
    const section = updated?.status == null ? 'pending' : 'handled';

    await withPreservedScroll(async () => {
      await fetchBothSummary();
      await loadEmployeeDetails(section, empId, { force: true });
    });

    if (section === 'pending') setOpenEmployeeCfPending(empCf);
    else setOpenEmployeeCfHandled(empCf);
  };

  // ---------- Salvataggio tariffa €/km ----------
  const handleSaveRatePerKm = async (payload, onSuccessCallback = null) => {
    try {
      const { refundId, rate_per_km, employeeId, section } = payload || {};
      if (!refundId || !employeeId || !section) {
        throw new Error('Parametri mancanti per il salvataggio della tariffa.');
      }

      // 1) PATCH
      await updateRatePerKm(token, refundId, rate_per_km === '' ? null : rate_per_km);

      // 2) chiudi inline editor
      onSuccessCallback?.();

      await withPreservedScroll(async () => {
        await Promise.all([
          loadEmployeeDetails('pending', employeeId, { force: true }),
          loadEmployeeDetails('handled', employeeId, { force: true }),
        ]);
        await fetchBothSummary();    // una sola call che riallinea sia pending che handled
        await fetchGlobalTotals();   // aggiorna i numerini globali in header
      });
      await Swal.fire({ icon: 'success', title: 'Tariffa aggiornata!', timer: 1200, showConfirmButton: false });
    } catch (err) {
      let errorMessage = 'Non è stato possibile salvare la tariffa.';
      const data = err?.response?.data;
      if (data) {
        const msgs = [];
        if (typeof data === 'string') msgs.push(data);
        else if (Array.isArray(data)) msgs.push(...data);
        else if (typeof data === 'object') {
          Object.values(data).forEach(v => {
            if (typeof v === 'string') msgs.push(v);
            else if (Array.isArray(v)) msgs.push(v.join(', '));
            else if (v && typeof v === 'object') msgs.push(Object.values(v).flat().join(', '));
          });
        }
        if (msgs.length) errorMessage = msgs.join('\n');
      } else if (err?.message) {
        errorMessage = err.message;
      }
      await Swal.fire({ icon: 'error', title: 'Errore', text: errorMessage });
    }
  };

  const handleUpdateSingleRequest = async (actionType, refund, refundKind, onSuccessCallback = null) => {
    if (!refund || !actionType) return;

    if (refund.status && (actionType === 'approved' || actionType === 'rejected')) {
      await handleEditStatus(refund);
      return;
    }

    switch (actionType) {
      case 'approved':
      case 'rejected':
        updateRecordStatus(refund, actionType, refundKind);
        break;
      case 'edit':
        // gestisci come già fai nel componente child se serve
        break;
      case 'delete':
        handleDelete(refund, refund.id, refundKind);
        break;
      case 'toggle-status':
        handleEditStatus(refund);
        break;
      case 'save-rate':
        await handleSaveRatePerKm(refund, onSuccessCallback);
        break;
      default:
        console.warn(`Azione "${actionType}" non gestita.`);
    }
  };

  const handleResetSelection = () => {
    setCurrentPageNull(1);
    setCurrentPageNoNull(1);
    setSelectedEmployee(null);
  };

  const handlePreviousMonthCalendar = () => {
    setCurrentPageNull(1);
    setCurrentPageNoNull(1);
    setSelectedMonthCalendar(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  };
  const handleNextMonthCalendar = () => {
    setCurrentPageNull(1);
    setCurrentPageNoNull(1);
    setSelectedMonthCalendar(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  };
  const handleSelectClickCalendar = () => setIsCalendarVisible(prev => !prev);

  // --------- EXPORT (invariato) ----------
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [isErrorDownload, setIsErrorDownload] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const handleExportCostRefunds = async () => {
    setIsLoadingDownload(true);
    setIsErrorDownload(false);

    const month = selectedMonth.getMonth() + 1;
    const year = selectedMonth.getFullYear();

    try {
      const { status, data } = await exportCostRefunds(token, month, year);

      const alreadyExists =
        status === 200 && String(data?.detail || "").toLowerCase().includes("già");

      Swal.fire({
        icon: alreadyExists ? "warning" : "success",
        title: alreadyExists ? "Esportazione già in corso" : "Esportazione avviata",
        html: `
          <div>
            ${
              alreadyExists
                ? "Esiste già un export per gli stessi parametri."
                : "Il file verrà generato in background e sarà scaricabile quando pronto."
            }
            <br/>
            <a href="/download_list" style="color:#4f46e5; text-decoration:underline;">
              Clicca qui
            </a>
            per andare alla pagina download.
          </div>
        `,
        confirmButtonText: "Chiudi",
      });

    } catch (error) {
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail;

      if (status === 404) {
        Swal.fire({
          icon: "info",
          title: "Nessun rimborso",
          text: detail || "Nessun rimborso spesa trovato per il periodo selezionato.",
          confirmButtonText: "OK",
        });
        return;
      }

      setIsErrorDownload(true);

      const msg =
        detail ||
        error?.message ||
        estraiMessaggiErrore(error) ||
        "Errore, riprova più tardi.";

      Swal.fire({
        icon: "error",
        title: "Errore durante l’esportazione",
        text: msg,
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoadingDownload(false);
    }
  };

  const selectedEmployeesProp = React.useMemo(
    () => (selectedEmployee ? [selectedEmployee] : []),
    [selectedEmployee]
  );
  const employeeRolePairsProp = React.useMemo(
    () => (selectedEmployee ? [{ employeeId: selectedEmployee.id }] : []),
    [selectedEmployee]
  );

  if (isError) return <div>Error loading data</div>;
  
  return (
    <div className="flex flex-col min-h-screen">
      <PopoverComponentCustom title='Rimborsi Spese' />
      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="flex-grow mx-auto w-full max-w-[1600px] px-4">
        <section>
          <div className="container-fluid w-full pt-8">
            <div className="px-4">
              <div className="bg-white border border-gray-300 rounded-xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                  <h3 className="text-normal font-semibold text-indigo-800 uppercase">Aggiungi Nuovo Rimborso</h3>
                  <p className="text-xs text-gray-500">Scegli il tipo di rimborso da creare</p>
                </div>

                {!showForm && !showFormRimborsoKm && (
                  <div className="inline-flex rounded-lg shadow-sm overflow-hidden">
                    <button
                      onClick={toggleForm}
                      className="px-4 py-2 text-sm font-semibold bg-indigo-50 text-indigo-700 hover:bg-indigo-100 transition flex items-center gap-2 focus:outline-none"
                    >
                      <CreditCardOutlinedIcon sx={{ fontSize: 18 }} />
                      Crea Rimborso Spesa
                    </button>
                    <button
                      onClick={toggleFormRimborsoKm}
                      className="px-4 py-2 text-sm font-semibold bg-indigo-50 text-indigo-700 hover:bg-indigo-100 transition border-l border-indigo-200 flex items-center gap-2 focus:outline-none"
                    >
                      <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 18 }} />
                      Crea Rimborso Chilometrico
                    </button>
                  </div>
                )}

                {showForm && !showFormRimborsoKm && (
                  <button
                    onClick={toggleForm}
                    className="px-4 py-2 text-sm font-semibold rounded-md bg-gray-300 text-gray-600 hover:bg-gray-400 transition inline-flex items-center gap-2"
                  >
                    <CreditCardOutlinedIcon sx={{ fontSize: 18 }} />
                    Annulla
                  </button>
                )}

                {showFormRimborsoKm && !showForm && (
                  <button
                    onClick={toggleFormRimborsoKm}
                    className="px-4 py-2 text-sm font-semibold rounded-md bg-gray-300 text-gray-600 hover:bg-gray-400 transition inline-flex items-center gap-2"
                  >
                    <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 18 }} />
                    Annulla
                  </button>
                )}
              </div>
            </div>

            {/* ── Container form (stile uniforme con header soft) ── */}
            <div className="mx-auto px-4 pt-8">
              {showForm && (
                <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
                  <div className="bg-indigo-50 px-4 py-3">
                    <h2 className="text-md font-semibold text-indigo-800 flex items-center gap-2 leading-none">
                      <CreditCardOutlinedIcon sx={{ fontSize: 18 }} className="shrink-0" />
                      <span>Nuovo Rimborso Spesa</span>
                    </h2>
                  </div>
                  <div className="px-4">
                    <FormCreaRimborsoCompany submitForm={submitForm} afterSubmit={handleAfterSubmit} />
                  </div>
                </div>
              )}

              {showFormRimborsoKm && (
                <div className="bg-white border border-gray-200 rounded-xl overflow-hidden mt-4">
                  <div className="bg-indigo-50 px-4 py-3">
                    <h2 className="text-md font-semibold text-indigo-800 flex items-center gap-2 leading-none">
                      <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 18 }} className="shrink-0" />
                      <span>Nuovo Rimborso Chilometrico</span>
                    </h2>
                  </div>
                  <div className="px-4">
                    <FormCreaRimborsoKmCompany submitForm={submitForm} afterSubmit={handleAfterSubmit} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
        
        <section>
          <div className="container-fluid w-full mt-6">
            <div className="px-4">
              <div className="grid gap-6 lg:grid-cols-2 items-start">
                
                <div className="space-y-2 lg:pr-6">
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold uppercase text-indigo-800">
                      Download Rimborsi Spese
                    </span>
                    <span className="text-[11px] text-gray-500 -mt-0.5">
                      Esporta il mese selezionato
                    </span>
                  </div>

                  <div className="flex items-center gap-3 flex-wrap lg:flex-nowrap">
                    <div className="w-60 lg:w-64 shrink-0">
                      <MonthYearListbox
                        selectedMonth={selectedMonth}
                        setSelectedMonth={setSelectedMonth}
                      />
                    </div>

                    <button
                      onClick={handleExportCostRefunds}
                      disabled={isLoadingDownload}
                      className={`text-sm px-4 py-1 rounded-md font-semibold whitespace-nowrap
                        ${isLoadingDownload
                          ? 'bg-indigo-200 text-white cursor-not-allowed'
                          : 'bg-indigo-600 text-white hover:bg-indigo-500'}`}
                    >
                      {isLoadingDownload ? 'Downloading...' :
                        <span><ArrowDownTrayIcon className='inline-block h-4 w-4' /> Scarica</span>}
                    </button>
                  </div>

                  {isErrorDownload && (
                    <p className="text-xs text-red-600">Si è verificato un errore. Riprova.</p>
                  )}
                </div>

                <div className="space-y-2 lg:border-l lg:border-gray-200 lg:pl-6">
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold uppercase text-indigo-800">
                      Seleziona dipendente da visualizzare
                    </span>
                    <span className="text-[11px] text-gray-500 -mt-0.5 text-transparent">-</span>
                  </div>

                  <div className="flex items-center gap-3 flex-wrap lg:flex-nowrap">
                    <div className="w-60 lg:w-64 shrink-0">
                      <ListBoxQueryMultiSelectEmployeesActiveContract
                        token={token}
                        selectedEmployees={selectedEmployeesProp}
                        employeeRolePairs={employeeRolePairsProp}
                        onChange={(list) => {
                          const employee = list[0] || null;
                          if ((selectedEmployee?.id || null) !== (employee?.id || null)) {
                            setSelectedEmployee(employee);
                          }
                        }}
                        placeholder="Seleziona dipendente"
                        filterBy="all"
                        buttonClassName="shadow-md border border-gray-200"
                      />
                    </div>

                    <button
                      onClick={handleResetSelection}
                      disabled={!selectedEmployee}
                      className={`text-sm font-semibold text-white px-4 py-1 rounded whitespace-nowrap
                        ${!selectedEmployee ? 'cursor-not-allowed bg-gray-300' : 'bg-indigo-600 hover:bg-indigo-400'}`}
                    >
                      Reset selezione
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className='grid md:grid-cols-5 sm:justify-start md:justify-around grid-cols-3 pt-12 px-4 text-sm uppercase font-semibold'>
          <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
            <button
              className='text-gray-500 font-semibold px-1 hover:bg-gray-100'
              onClick={handlePreviousMonthCalendar}
            >
              <ChevronLeftIcon className="w-5 h-5 cursor-pointer" />
            </button>
          </div>
          <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3 text-gray-500'>Seleziona Mese</div>
          <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start md:hidden block'>
            <button
              className='text-gray-500 font-semibold px-1 hover:bg-gray-100'
              onClick={handleNextMonthCalendar}
            >
              <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
            </button>
          </div>
          <div
            onClick={handleSelectClickCalendar}
            style={{ cursor: 'pointer' }}
            className='col-span-3 md:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 w-full justify-between text-gray-600'
          >
            <div>
              {selectedMonthCalendar.toLocaleDateString('it-IT', { month: 'long' })}, {selectedMonthCalendar.getFullYear()}
            </div>
            {!isCalendarVisible ? <ChevronDownIcon className='h-4 w-4 bg-indigo-100 rounded-md' /> : <ChevronUpIcon className='h-4 w-4 bg-indigo-100 rounded-md' />}
          </div>
          <div className='col-span-1 p-2 align-start justify-start hidden md:block'>
            <button
              className='text-gray-500 font-semibold px-1 hover:bg-gray-100 flex items-start'
              onClick={handleNextMonthCalendar}
            >
              <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
            </button>
          </div>
        </div>

        {isCalendarVisible && (
          <div className='px-4'>
            <CalendarMonthSelect
              selectedMonth={selectedMonthCalendar}
              onMonthSelect={(date) => setSelectedMonthCalendar(date)}
              onCloseCalendar={handleSelectClickCalendar}
            />
          </div>
        )}
        
        {/* RICHIESTE DA APPROVARE */}
        <div className='p-4 mt-4'>
          {isLoadingPending ? (
            <Fetching />
          ) : (
            <PendingRefundRequests
              groupedRecords={recordToReview}
              refundsCache={pendingDetails}
              onOpenEmployee={(emp) => loadEmployeeDetails('pending', emp.id)}
              onProcessAllApproved={(employee, refunds, totalEmployeePending) => handleProcessAllRequests('approved', employee, refunds, totalEmployeePending)}
              onProcessAllRejected={(employee, refunds, totalEmployeePending) => handleProcessAllRequests('rejected', employee, refunds, totalEmployeePending)}
              totalPendingCount={totalPendingCount}
              globalPendingCount={globalPendingCount}  
              handleProcessAllRequests={handleProcessAllRequests}
              onRefundAction={(actionType, refund, refundKind, onSuccessCallback) =>
                handleUpdateSingleRequest(actionType, refund, refundKind, onSuccessCallback)
              }
              submitForm={submitForm}
              afterSubmitEditRecord={handleAfterSubmitEditRecord}
              openEmployeeCf={openEmployeeCfPending}
              setOpenEmployeeCf={setOpenEmployeeCfPending}
            />
          )}

          {totalPagesNull > 1 && (
            <div className="flex items-center justify-between border border-gray-300 rounded-b-lg py-4 bg-gray-50">
              <button
                onClick={() => setCurrentPageNull(p => Math.max(1, p - 1))}
                disabled={currentPageNull === 1}
                className={`border rounded-md shadow-md text-sm font-semibold text-center px-3 py-1 ml-4 ${currentPageNull === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'}`}
              >
                Pagina precedente
              </button>

              <div className="text-sm font-semibold text-gray-800 px-2">
                Pagina {currentPageNull} di {totalPagesNull}
              </div>

              <button
                onClick={() => setCurrentPageNull(p => Math.min(totalPagesNull, p + 1))}
                disabled={currentPageNull === totalPagesNull}
                className={`border rounded-md shadow-md text-sm font-semibold text-center px-3 py-1 mr-4 ${currentPageNull === totalPagesNull ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'}`}
              >
                Pagina successiva
              </button>
            </div>
          )}
        </div>

        {/* RIEPILOGO (GESTITE) */}
        <div className='p-4 mt-4'>
          {isLoadingHandled ? (
            <Fetching />
          ) : (
            <HandledRefundRequests
              groupedRecords={records}
              refundsCache={handledDetails}
              onOpenEmployee={(emp) => loadEmployeeDetails('handled', emp.id)}
              submitForm={submitForm}
              afterSubmitEditRecord={handleAfterSubmitEditRecord}
              onRefundAction={handleUpdateSingleRequest}
              openEmployeeCf={openEmployeeCfHandled}
              setOpenEmployeeCf={setOpenEmployeeCfHandled}
            />
          )}

          {totalPagesNoNull > 1 && (
            <div className="flex items-center justify-between border border-gray-300 rounded-b-lg py-4 bg-gray-50">
              <button
                onClick={() => setCurrentPageNoNull(p => Math.max(1, p - 1))}
                disabled={currentPageNoNull === 1}
                className={`border rounded-md shadow-md text-sm font-semibold text-center px-3 py-1 ml-4 ${currentPageNoNull === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'}`}
              >
                Pagina precedente
              </button>

              <div className="text-sm font-semibold text-gray-800 px-2">
                Pagina {currentPageNoNull} di {totalPagesNoNull}
              </div>

              <button
                onClick={() => setCurrentPageNoNull(p => Math.min(totalPagesNoNull, p + 1))}
                disabled={currentPageNoNull === totalPagesNoNull}
                className={`border rounded-md shadow-md text-sm font-semibold text-center px-3 py-1 mr-4 ${currentPageNoNull === totalPagesNoNull ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'}`}
              >
                Pagina successiva
              </button>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RimborsoSpeseCompany;